import React  from 'react';

import Layout from '../components/layouts/standard-page.js';
import ContentLayout from '../components/layouts/content-standard-page.js';
import Card from '../components/card.js';
import CardBody from '../components/card-body.js';

import LanguageSelector from '../components/inputs/language-selector.js';
import LanguageSupportSelector from '../components/inputs/language-interface-selector.js';
import {Row , Col , Alert , FormGroup , ControlLabel , FormControl , Button} from 'react-bootstrap';
import ContentService from '../services/content-service.js';
import ContentStore   from  '../store/content-store.js';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import InternationalizationStore from '../store/internationalization-store.js';
import { FormattedMessage } from 'react-intl';

export default class ContentMaker extends React.Component{

    constructor(props) {
        super(props);

        this.state = {catalogID:this.props.params.classID , savingContent:false, name:"" , learningLanguage:{ietf:null},supportLanguage:{ietf:null} , modules:[] };
    }


    handleLearningChange(learningLanguage){
        this.setState({learningLanguage:learningLanguage});
    }

    handelSupportChange(supportLanguage){
        this.setState({supportLanguage:supportLanguage});
    }

    handleChange(e) {
        this.setState({ name: e.target.value });
    }


    handleDescripitonChange(e){
        this.setState({ description: e.target.value });
    }

    handleSubmit(){

        if(this.state.name.length == 0)
        {
            return;
        }

        if(sessionStorage.product == "hodder") this.state.supportLanguage = this.state.learningLanguage;

        ContentService.makeNewModule(this.state.name , this.state.learningLanguage.ietf , this.state.supportLanguage.ietf , this.state.description).then(function(response){
            this.gotoCheckout(response.uid);
        }.bind(this))

    }

    getTableData(){
        return [];
    }

    languageImage(cell, row) {
        return <img className="avatar-img" src={"img/flags/"+cell+".png"} alt=""/>
    }

    editButton(cell, row){

        console.log(cell);
        return <Button onClick={this.gotoCheckout.bind(this , cell)} block>Edit</Button>;

    }
    seeButton(cell, row){
        return <Button block>See Vocab</Button>;
    }

    copyButton(cell, row){
        return <Button block>Duplicate</Button>;
    }

    gotoCheckout(id){
        window.location.hash = 'builder/checkout/'+id;
    }

    render()
    {
        let warning = null;

        if(this.state.learningLanguage.ietf == this.state.supportLanguage.ietf)
        {
            warning = <Alert bsStyle="warning">
                <FormattedMessage id={"ui-2225"} defaultMessage={"Add"} />
            </Alert>
        }

        let support =  <FormGroup controlId="formBasicText">
            <ControlLabel><FormattedMessage id={"ui-2212"} defaultMessage={"Add"} /></ControlLabel>
            <LanguageSupportSelector setSupport onSelect={this.handelSupportChange.bind(this)}/>
        </FormGroup>

        if(sessionStorage.product == "hodder") support = null;

        return <Layout>

            <Card>
                <CardBody>
                    <div className="p-20 b-0 ">
                        <Row>
                            <Col md={6}>
                                <FormGroup
                                    controlId="formBasicText">
                                    <ControlLabel><FormattedMessage id={"ui-2202"} defaultMessage={"Add"} /></ControlLabel>
                                    <FormControl
                                        type="text"
                                        value={this.state.name}
                                        placeholder={InternationalizationStore.getTranslation("ui-2226" , "Enter a title")}
                                        onChange={this.handleChange.bind(this)}
                                        />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <FormGroup
                                    controlId="formBasicText"
                                    >
                                    <ControlLabel><FormattedMessage id={"ui-2211"} defaultMessage={"Add"} /></ControlLabel>
                                    <LanguageSelector onSelect={this.handleLearningChange.bind(this)}/>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                {support}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <FormGroup
                                    controlId="formBasicText"
                                    >
                                    <ControlLabel><FormattedMessage id={"ui-2203"} defaultMessage={"Add"} /></ControlLabel>
                                    <FormControl
                                        type="text"
                                        value={this.state.description}
                                        placeholder=""
                                        onChange={this.handleDescripitonChange.bind(this)}
                                        />
                                </FormGroup>
                            </Col>
                            <Col md={12}>
                                {warning}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <Button onClick={this.handleSubmit.bind(this)} className="pull-right" bsStyle="primary"><FormattedMessage id={"ui-236"} defaultMessage={"Add"} /></Button>
                            </Col>

                        </Row>
                    </div>
                </CardBody>
            </Card>

        </Layout>
    }

}


// WEBPACK FOOTER //
// ./src/screens/content-create.js